export function scrollToElement(elementId: string, scrollNode: HTMLElement | null) {
  const element = document.getElementById(elementId);
  if (element && scrollNode) {
    const offset = element.offsetTop - scrollNode.offsetTop;
    scrollNode.scrollTo({ behavior: 'smooth', top: offset });
  }
}
